/**
 * Single source for PostHog URLs used by the web app.
 * @see `shared.ts` (ingest / posthog-js `api_host`)
 * @see `server.ts` (PostHog node client uses the same ingest `HOST` from `shared.ts`)
 */
/**
 * PostHog managed reverse proxy (CNAME → cf-prod-eu-proxy.europehog.com).
 * Serves PostHog paths at the ROOT — no path prefix. Bypasses ad-blockers.
 */
export const POSTHOG_INGEST_ORIGIN = 'https://t.funkey.be' as const;

/** Direct PostHog ingest origin (server-side use, bypasses proxy). */
export const POSTHOG_INGEST_ORIGIN_DIRECT = 'https://eu.i.posthog.com' as const;

/** UI host so toolbar/links resolve to the real PostHog app. */
export const POSTHOG_UI_HOST = 'https://eu.posthog.com' as const;

export const POSTHOG_API_BASE_URL = 'https://eu.posthog.com/api/projects/51268' as const;

/** Hostnames the browser may call during E2E (ingest + project API); derived from the origins above. */
export const POSTHOG_CYPRESS_BLOCKED_HOSTNAMES: readonly string[] = [
    new URL(POSTHOG_INGEST_ORIGIN_DIRECT).hostname,
    new URL(POSTHOG_API_BASE_URL).hostname,
];
